export default __webpack_public_path__ + "static/media/hht2_ep16_speaking_01.5efae28f.png";